import { computed, type Ref } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { MODULE_ELECTIVE_CANDIDATES } from '@/graphql/Queries/moduleElectiveOfferings';
import type { ModuleElectiveCandidatesQuery } from '@/types/operations';

export function useModuleElectiveCandidates(moduleId: Ref<string>, calendarId: Ref<string | null>, query: Ref<string>) {
  const { result, loading, error } = useQuery<ModuleElectiveCandidatesQuery>(MODULE_ELECTIVE_CANDIDATES,
    () => ({ moduleId: moduleId.value, calendarId: calendarId.value, query: query.value }),
    () => ({ enabled: !!moduleId.value && !!calendarId.value, fetchPolicy: 'network-only', debounce: 250 }));
  return { courses: computed(() => loading.value ? [] : result.value?.moduleElectiveCandidates ?? []), loading, error };
}
